import React from "react";

const Loading = () => {
  return (
    <div className="loading">
      <div className="lds-dual-ring"></div>
    </div>
  );
};

export default Loading;
